import React from 'react';
import "./Styles/Calculators.css";
import "./Styles/UserWelcome.css";
import "./Styles/UserWelcomeIntro.css";
import NavBar from '../NavBar';
import CalculatorDiabetes from './Components/CalculatorPages/CalculatorDiabetes';
//import { BrowserView, MobileView, isBrowser, isMobile } from 'react-device-detect';
import UserInfoProvider from './Components/Context/UserInfoContext';
import MedicalContextProvider from './Components/Context/MedicalContext';

function CalculatorDiabetesRoute() {
    return (
        <UserInfoProvider>
            <MedicalContextProvider>
                <div className="UserProfileDiabetesRoutePage">
                    <div className="UserProfileDiabetesRouteNavBar">      
                        <NavBar/>
                    </div>
                    <div className="CalculatorDiabetesRouteBlock">
                        <CalculatorDiabetes/>
                    </div>
                </div>
            </MedicalContextProvider>
       </UserInfoProvider>
    );
}

export default CalculatorDiabetesRoute;